'use client';

import { Suspense } from 'react';

import dynamic from 'next/dynamic';

const SerialHlsPlayer = dynamic(
  () => import('@/views/MovieDetailsView/components/SerialPlayer/SerialHlsPlayer'),
  {
    ssr: false,
  },
);

export const SerialPlayer = (props: { isMiniPlayer?: boolean }) => {
  const { isMiniPlayer } = props;

  return (
    <Suspense>
      <SerialHlsPlayer isMiniPlayer={isMiniPlayer} />
    </Suspense>
  );
};
